import ShopRecV from './shop-rec-v'
export default ShopRecV